import request from '@/utils/request'
import { envInfo } from '@/constants/envInfo'

/**
*查询L1统计图形的数据
 * @param params
 */
export function getMonth(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/device/month',
        method: 'get',
        params
    })
}
export function getSeason(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/device/season',
        method: 'get',
        params
    })
}
export function getYear(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/device/year',
        method: 'get',
        params
    })
}
export function getChild(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/device/childType',
        method: 'get',
        params
    })
}
export function getArea(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/device/area',
        method: 'get',
        params
    })
}
/**
*查询L1列表的数据
 * @param params
 */
export function listLevel1(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/device/query/list',
        method: 'get',
        params
    })
}

export function listChildLevel1(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/device/childtype/list',
        method: 'get',
        params
    })
}
/**
* 导出excel
* @param params
*/
export function exportQuery(params) {
    return request({
      url: envInfo.bgApp.cameraPath + `/camera/device/export`,
      method: 'post',
      data: params
    })
  }
  /**
* 导出excel
* @param params
*/
export function exportChildLevelQuery(params) {
    return request({
      url: envInfo.bgApp.cameraPath + `/camera/device/export/childlevel`,
      method: 'post',
      data: params
    })
  }